export default [
    { path: '*', redirect: '/' },
    {
        path: '/',
        name: 'frontend',
        component: () => import('./views/frontend.vue'),
        children: [
            {
                path: '/',
                name: 'home',
                meta: {
                    title: '',
                    keepAlive: true
                },
                component: () => import('./views/frontend/home.vue')
            },
            {
                path: '/about',
                name: 'about',
                meta: {
                    title: '关于我们'
                },
                component: () => import('./views/frontend/about.vue')
            },
            {
                path: '/news',
                name: 'news',
                component: () => import('./views/frontend/news.vue'),
                meta: {
                    title: '新闻中心',
                    keepAlive: true
                },
            },
            {
                path: '/news/:id([1-9]\\d*)',
                name: 'newsDetail',
                meta: {
                    title: '新闻详情'
                },
                component: () => import('./views/frontend/newsDetail.vue')
            },
            {
                path: '/products',
                name: 'products',
                meta: {
                    title: '产品中心',
                    keepAlive: true
                },
                component: () => import('./views/frontend/products.vue')
            },
            {
                path: '/transaction/:id([1-9]\\d*)',
                name: 'product',
                meta: {
                    title: '产品详情'
                },
                component: () => import('./views/frontend/product.vue')
            },
            {
                path: '/shoppingcart',
                name: 'shoppingCart',
                meta: {
                    auth: true,
                    title: '我的购物车',
                    keepAlive: true
                },
                component: () => import('./views/frontend/shoppingCart.vue')
            },
            {
                path: '/pay',
                name: 'pay',
                meta: {
                    auth: true,
                    title: '订单支付',
                    keepAlive: true
                },
                component: () => import('./views/frontend/pay.vue')
            },
            {
                path: '/orders',
                name: 'orders',
                meta: {
                    auth: true,
                    title: '订单支付',
                    keepAlive: true
                },
                component: () => import('./views/frontend/orders.vue')
            },
            {
                path: '/expresses',
                name: 'expresses',
                meta: {
                    auth: true,
                    title: '我的快递',
                    keepAlive: true
                },
                component: () => import('./views/frontend/expresses.vue')
            },
            {
                path: '/receiptor',
                name: 'receiptor',
                meta: {
                    auth: true,
                    title: '我的收件人'
                },
                component: () => import('./views/frontend/receiptor.vue')
            },
            {
                path: '/shop/:id([1-9]\\d*)',
                name: 'shop',
                meta: {
                    title: '店铺详情'
                },
                component: () => import('./views/frontend/shop.vue')
            },
            {
                path: '/shopList',
                name: 'shopList',
                meta: {
                    title: '店铺列表'
                },
                component: () => import('./views/frontend/shopList.vue')
            },
            {
                path: '/login',
                name: 'buyerLogin',
                meta: {
                    title: '登录'
                },
                component: () => import('./views/frontend/login.vue')
            },
            {
                path: '/register',
                name: 'buyerRegister',
                meta: {
                    title: '注册'
                },
                component: () => import('./views/frontend/register.vue')
            },
            {
                path: '/password',
                name: 'password',
                meta: {
                    auth: true,
                    title: '修改密码'
                },
                component: () => import('./views/frontend/password.vue')
            },
            {
                path: '/myCenter',
                name: 'myCenter',
                meta: {
                    auth: true,
                    title: '我的资料'
                },
                component: () => import('./views/frontend/myCenter.vue')
            }
        ]
    }
]
